import Iconify from "@/components/ui/Iconify";
import { motion } from "framer-motion";

const StarClickAnimation = ({ isStarred, iconClassName }) => {
  const starVariants = {
    starred: {
      scale: [1, 1.5, 1], // Scale up and then back down
      transition: {
        duration: 0.2,
        ease: "easeInOut",
        times: [0, 0.5, 1],
      },
    },
    unstarred: {
      scale: 1,
      transition: { duration: 0.2 },
    },
  };

  return (
    <motion.span
      className="select-none cursor-pointer"
      variants={starVariants}
      initial="unstarred"
      animate={isStarred ? "starred" : "unstarred"}
    >
      <Iconify
        icon={isStarred ? "ph:star-fill" : "ph:star"}
        className={`!w-6 !h-6 ${iconClassName} ${
          isStarred
            ? "!text-[#ffb02e]"
            : "!text-dark_bg_grey dark:!text-dark_primary_label"
        }`}
      />
    </motion.span>
  );
};

export default StarClickAnimation;
